import React from 'react';
import routes from '../routing/routesApp';
import Navbar from '../components/partials/navbar/Navbar';
import Footer from '../components/partials/footer/Footer';
import App from '../App';
import {SkipLinks} from '../components/partials/SkipLinks';

const AppEp = () => (
    <App
        routes={routes}
        routesWrapper={({children}) => <>
            <SkipLinks />
            <Navbar />
            <div className="navbar-placeholder" id="main-content" role="main">
                {children}
            </div>
            <Footer />
        </>}
    />
);

export default AppEp;
